import React, { useState, useEffect, useCallback, useContext, createContext } from 'react';
import {
  User, Briefcase, Calendar, IndianRupee, Phone, Mail,
  CheckSquare, Award, Star, MessageSquare, MapPin,
  GraduationCap, ClipboardList, CreditCard,
  Building2, Link as LinkIcon, Linkedin, Facebook, Twitter, Instagram, Github, Brain, FileText, Download,
  Sparkles, Zap, Gem, AlertTriangle, Flame,
  Undo2, HelpCircle,
  Slice
} from 'lucide-react';


/* * =================================================================================
 * SECTION 1: REAL PROJECT IMPORTS
 * (INSTRUCTION: UNCOMMENT THIS SECTION WHEN MOVING TO PRODUCTION)
 * =================================================================================
 */

import { useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../context/AppContext';
import { simpleDeleteCall, simpleGetCallWithErrorResponse, PostCallWithErrorResponse } from '../Api/ApiServices';
import { ApiConfig } from '../Api/ApiConfig';
import { formatDate, formatToDDMMYYYY } from '../common';
import { toastMsg } from '../component/toast';
import FileSaver from 'file-saver';
import PersonalityDetails from '../component/personalityDeatils';



/* * =================================================================================
 * SECTION 2: PREVIEW MOCKS
 * (INSTRUCTION: DELETE THIS ENTIRE SECTION WHEN MOVING TO PRODUCTION)
 * =================================================================================
 */



// Mock Hooks & Utils
// const useNavigate = () => (path) => console.log("Navigating to:", path);
// const useParams = () => ({ code: "C12345", userId: "U98765" });
// const formatDate = (dateString) => dateString ? new Date(dateString).toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' }) : "";
// const toastMsg = (type, msg) => { console.log(`[${type.toUpperCase()}] ${msg}`); alert(`${type.toUpperCase()}: ${msg}`); };
// const FileSaver = { saveAs: (blob, name) => alert(`Downloading file: ${name} (Mocked)`) };


// const ApiConfig = {
//   GET_SUMMARY_REPORT: "GET_SUMMARY_REPORT",
//   UPDATE_TAGS: "UPDATE_TAGS",
//   DOWNLOAD_SUMMARY_REPORT: "DOWNLOAD_SUMMARY_REPORT",
//   DELETE_USER_AND_DEP: "DELETE_USER_AND_DEP"
// };


// Mock Data
const DEFAULT_DATA = {
  candidateName: "Deepak Arondekar",
  appliedRole: "Plant Head",
  appliedCompany: "Synnat Pharma",
  mobile: "9881100274",
  email: "sameer.kutty@cloudxperte.com",
  yearsOfExperience: "30 Years",
  currentLocation: "Mumbai",
  expectedSalary: "18 to 22 Lakhs per year",
  availableBy: "2025-12-07T00:00:00",
  buyOutOption: false,
  technicalScore: "10 / 25",
  resumeUrl: "#",
  tags: [
    { name: "Shortlist", email: "admin@lywo.com", createdAt: "2024-12-13T14:15:00" }
  ],
  resumeMatch: [{
    match: "High Match",
    onlinePresence: [],
    resumeEducationDetails: [
      {
        educationType: "M. Sc.",
        institution: "Goa University",
        percentageCGPA: "N/A",
        completionYear: "1989"
      },
      {
        educationType: "B. Sc.",
        institution: "Mumbai University",
        percentageCGPA: "N/A",
        completionYear: "1987"
      }
    ],
    resumeMatchSkills: [
      { name: "Micro planning" }, { name: "cGMP" }, { name: "USFDA" }, { name: "European Guidelines" },
      { name: "Indian FDA" }, { name: "SAP" }, { name: "Computer (Word, Excel, Power Point)" },
      { name: "Unit Operation" }, { name: "Process Safety" }, { name: "Process Chemistry" }, { name: "ETP" },
      { name: "Statutory requirement of DISH, MPCB, EC" }, { name: "HAZOP study" }, { name: "GMP documentation" },
      { name: "Troubleshooting" }, { name: "SOPs" }, { name: "Marathi" }, { name: "Hindi" }, { name: "English" },
      { name: "MFRs" }, { name: "SMF" }, { name: "QMP" }, { name: "APQR" }, { name: "Process Validation" },
      { name: "Equipment Qualification Protocol" }, { name: "Reports" }, { name: "Statutory Compliance" },
      { name: "Regulatory compliance" }, { name: "Manpower Recruitment" }, { name: "BMRs" }, { name: "HSE" },
      { name: "Supply chain" }, { name: "Warehouse Management" }, { name: "Production Management" },
      { name: "Plant Management" }, { name: "Manufacturing Operations" }, { name: "Commissioning" },
      { name: "Formulation Project Erection" }, { name: "Brown Field API Project" }, { name: "Green Field API Project" },
      { name: "Customer Audit" }, { name: "Safety Audit" }, { name: "ISO" }, { name: "Local FDA" }, { name: "WHO" },
      { name: "EDQM" }, { name: "USFDA Audits" }, { name: "API Pharmaceutical Industry" }, { name: "Process Management" },
      { name: "Quality System Implementation" }, { name: "Performance Management" }, { name: "Installation" },
      { name: "Commissioning" }, { name: "Environment Management" }, { name: "Cost Optimization" },
      { name: "Team Management" }, { name: "Operation" }, { name: "Maintenance" }, { name: "System Implementation" },
      { name: "Production" }, { name: "Quality Assurance" }, { name: "Quality Control" }, { name: "Administration" },
      { name: "Shop floor Operations" }
    ],
    matchDetails: [
      { title: "Production Capacity Achievement", description: "Achieved Production capacity 50 Tones from 30 Tons of Cefuroxime Axetile Povidone Mixture per year in Sandoz Pvt Ltd as per Market demand" },
      { title: "Award", description: "Product quality and yield achieved without single batch failure above budget norms and got Global Excellence Site Award to Sandoz Pvt Ltd in the year 2016." },
      { title: "Quality Improvement", description: "Quality of Niacin increased from 75% to 100% in Assay" },
      { title: "Production Capacity Achievement", description: "Achieved Production capacity 92 Tones from 32 Tons of Sodium Ascorbate per month in Reckon Organics Pvt Ltd as per Market demand." },
      { title: "Production Capacity Achievement", description: "Achieved Production capacity 70 Tones from 41 Tons of Ascorbic Acid per month in Reckon Organics Pvt Ltd as per Market demand." },
      { title: "Production Planning", description: "Planning to increase Oxidation from 28752 kgs to 38000 kgs per day." },
      { title: "Quality Improvement", description: "Quality of Niacinamide CG grade increased from 65% to 100% in Niacin ppm Limit Less Than 100 PPM" },
      { title: "Project Completion", description: "Completed Brown field API Project in 6 months and commercial Production started in Saitech Pharmaceuticals Pvt Ltd." }
    ],
    workHistoryDetails: [
      { position: "Head API Manufacturing", company: "Lasons India Pvt Ltd", duration: "13.09.2021 - Present", focus: "API Manufacturing,Plant Management,Production Management,Quality Improvement,Oxidation Planning,Niacin,Niacinamide,Sodium Nitrate,Niacin Sulphate" },
      { position: "General Manager API Operations", company: "Reckon Organics Pvt Ltd", duration: "17.12.2017 to 10.09.2021", focus: "API Operations,Production Capacity Improvement,Ascorbic Acid,Sodium Ascorbate,Ascorbic Acid Coated,Market Demand Analysis" },
      { position: "General Manager - API Manufacturing", company: "Saitech Pharmaceuticals Pvt Ltd", duration: "02.01.2017 to 14.12.2017", focus: "API Manufacturing,Brown field API Project,Celecoxib,Etoricoxib,Commercial Production" },
      { position: "Manager Production – API Manufacturing", company: "Sandoz Pvt Ltd", duration: "17.04.2001 to 31.12.2016", focus: "API Manufacturing,Cefprozil,Cefixime,Cefuroxime,Cefpodoxime,Co-povidone mixture,Product Quality,Yield Improvement,Global Excellence Site Award" },
      { position: "Asst. Manager Production – API Manufacturing", company: "Kopran Ltd", duration: "06.01.1997 to 10.04.2001", focus: "API Manufacturing,Cephalexin,Ciprofloxacin,Atenolol,PHPA" },
      { position: "Manager Production API Manufacturing", company: "Dee Pharma Laboratories Ltd", duration: "08.10.1994 to 31 12. 1996", focus: "API Manufacturing,Ampicillin,Amoxicillin" },
      { position: "Asst. Manager Production – API Manufacturing", company: "Boehringer Mannheim (India) Ltd", duration: "26.11.1991 to 30.09.1994", focus: "API Manufacturing,Chloramphenicol" },
      { position: "Executive Production – API Manufacturing", company: "Indo Pharma Pharmaceutical Works Ltd", duration: "14.11.1989 to 25.11.1991", focus: "API Manufacturing,Dicyclomine Hydrochloride,Silver Sulphadiazine" }
    ]
  }],
  customQuestions: [
    { questionText: "Please confirm if you are at least 45 years of age.", ans1: "No" },
    { questionText: "Do you have a minimum of 20 years of experience in the API or pharmaceutical industry?", ans2: "Yes" },
    { questionText: "Have you worked in regulated markets for at least the past 5 years?", ans3: "Yes" },
    { questionText: "Have you held a senior management role, such as Plant Head, for more than one year?", ans4: "Yes" },
    { questionText: "Have you independently managed a pharmaceutical manufacturing unit in your previous role?", ans5: "Yes" }
  ],
  adminNotes: [],
  personalityGroups: [],
  personalityMatch: "74%",
  secondaryPersonalityMatch: "67%",

  // Job Behaviors
  selectedBehaviourMatch1: [
    { behaviourName: "Self Confidence", description: "Should have a high degree of confidence in their abilities and actions." },
    { behaviourName: "Sensitivity", description: "Should be mostly considerate of how others are impacted by them in their role." },
    { behaviourName: "Thoughtfulness", description: "Should be careful about their activities and decisions to avoid unexpected outcomes." },
    { behaviourName: "Independence", description: "Will not have much guidance on how and when things are to be done and completed." }
  ],


  // Personalities
  primaryProfile: {
    profileName: "Perfectionist",
    shortDescriptions: "A well planned, straight forward, dynamic and competitive individual that believes in getting things right and doesn’t shy away from challenges to get things done. Prioritizes accuracy and delivers quality.",
    theirUniqueness: "Attention to detail; Tries innovative approaches using existing systems.",
    strengths: "Tenacity, Quality control, Handling large amounts of detail, Analysing data, Building systems, Competing to win, Results-focused, Striving to be the best",
    valueToOrganization: "Can bring positive change to the team by challenging them and raising the standards.",
    challenges: "Bored with routine work; Gets lost in detail.",
    motivations: "Unique accomplishments and dominance"
  },
  secondaryProfile: {
    profileName: "Leader",
    shortDescriptions: "A self-driven, innovative, confident and dynamic individual that likes taking responsibility and has a constant drive to make things better. While they are ambitious and assertive, they are also considerate of the needs of others and bring the best out of everyone around them.",
    theirUniqueness: "Accommodating and inspiring; Drive to make things better.",
    strengths: "Driven, Innovative, Practical, Self-reliant, Leadership ability, Confident, Clear thinking",
    valueToOrganization: "Persistently accomplishes goals with inclusivity of team.",
    challenges: "Impatience when things don’t go a certain way; Being managed.",
    motivations: "Opportunity to get things done in their way; Supporting the team"
  },
};



/* * =================================================================================
 * END OF MOCKS
 * =================================================================================
 */


// Static Content for UI Mapping (Keep active in production)
const MODAL_CONTENT = {
  // Can be populated if static mapping is needed, but dynamic data from API is preferred
};


/**
 * =================================================================================
 * STYLES
 * =================================================================================
 */
const CSS_STYLES = `
:root {
  --lywo-primary: #081DA5;
  --lywo-bg: #f5f8ff;
  --lywo-text: #212529;
  --lywo-font-base: 13px; /* Reduced base font slightly */
  --lywo-info-bg: #eef2ff;
  --lywo-success-bg: #d1e7dd; --lywo-success-text: #198754;
  --lywo-warning-bg: #fff3cd; --lywo-warning-text: #856404;
  --lywo-danger-bg: #f8d7da; --lywo-danger-text: #dc3545;
  --lywo-border-light: #e2e8f0;
  --lywo-radius: 0.375rem;
}


body { font-family: 'Inter', sans-serif !important; font-size: var(--lywo-font-base); color: var(--lywo-text); background-color: #f0f2f5; margin: 0; }
.mainWrap { background-color: var(--lywo-bg); min-height: 100vh; padding-bottom: 2rem; }


/* Header */
.app-header { background: #fff; border-bottom: 1px solid var(--lywo-border-light); padding: 0.4rem 0.8rem; display: flex; justify-content: space-between; align-items: center; box-shadow: 0 1px 2px rgba(0,0,0,0.05); margin-bottom: 0.75rem; position: sticky; top: 0; z-index: 100; }
.header-main { flex: 1; display: flex; align-items: center; gap: 10px; }
.header-logo-text { font-weight: 900; font-size: 1.2rem; color: var(--lywo-primary); letter-spacing: -1px; }
.header-title { font-size: 1.2rem; font-weight: 700; color: #000000; margin: 0; line-height: 1.1; }
.header-right { text-align: right; margin-right: 1rem; }
.contact-bar { display: flex; gap: 1rem; font-size: 0.8rem; color: #475569; flex-wrap: wrap; justify-content: flex-end; }
.contact-item { display: flex; align-items: center; gap: 0.4rem; font-weight: 500; }
.contact-item svg { color: var(--lywo-primary); opacity: 0.8; }


/* Common UI Atoms */
/* Reduced padding from 0.75rem to 0.5rem */
.card { background: #fff; border-radius: var(--lywo-radius); border: 1px solid var(--lywo-border-light); padding: 0.5rem; box-shadow: 0 0.125rem 0.25rem rgba(0,0,0,0.05); height: 100%; }
.section-title { font-size: 0.75rem; font-weight: 700; color: #64748b; text-transform: uppercase; margin-bottom: 0.25rem; display: flex; align-items: center; gap: 0.4rem; letter-spacing: 0.5px; }


.icon-box { width: 24px; height: 24px; border-radius: 6px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.icon-box.blue { background: var(--lywo-info-bg); color: var(--lywo-primary); }
.icon-box.green { background: var(--lywo-success-bg); color: var(--lywo-success-text); }
.icon-box.purple { background: #faf5ff; color: #9333ea; }
.icon-box.gray { background: #f1f5f9; color: #64748b; }


.badge { display: inline-block; padding: 0.15rem 0.35rem; border-radius: 3px; font-size: 0.65rem; font-weight: 700; text-transform: uppercase; }
.badge.good { background: var(--lywo-success-bg); color: var(--lywo-success-text); }
.badge.bad { background: var(--lywo-danger-bg); color: var(--lywo-danger-text); }
.badge.match { background: #f97316; color: white; padding: 0.15rem 0.4rem; }


/* Profile Section */
.profile-row { display: flex; align-items: center; gap: 0.4rem; margin-bottom: 0.25rem; }
.profile-label { font-size: 12px; color: #64748b; margin: 0; font-weight: 600; text-transform: uppercase; }
.profile-value { font-weight: 600; font-size: 0.85rem; color: var(--lywo-text); margin: 0; }
.edu-box { background: #f8fafc; padding: 0.4rem; border-radius: var(--lywo-radius); border: 1px solid var(--lywo-border-light); margin-top: 0.25rem; width: 100%; }
.edu-row { display: flex; justify-content: space-between; font-size: 0.75rem; margin-top: 0.15rem; }


/* Questionnaire */
/* Updated font size to 0.75rem for consistency */
.list-item { border-bottom: 1px solid var(--lywo-border-light); padding: 0.25rem 0; display: flex; justify-content: space-between; align-items: center; font-size: 0.75rem; }
.list-item:last-child { border: none; padding-bottom: 0; }


/* Notes & Tags */
.note-card { background: #f8fafc; padding: 0.4rem; border-radius: var(--lywo-radius); border: 1px solid var(--lywo-border-light); margin-bottom: 0.35rem; }
.note-header { display: flex; justify-content: space-between; margin-bottom: 0.15rem; font-size: 0.75rem; }
.note-tags-row { display: flex; flex-wrap: wrap; gap: 0.2rem; margin-bottom: 0.2rem; }
.note-tag { padding: 1px 5px; border-radius: 3px; font-size: 0.7rem; font-family: monospace; font-weight: 600; border: 1px solid transparent; }


/* Skills */
.skill-tag { display: inline-block; padding: 0.1rem 0.4rem; background: #f8f9fa; color: var(--lywo-text); border-radius: 4px; font-size: 0.75rem; font-weight: 500; margin: 0 0.15rem 0.15rem 0; border: 1px solid var(--lywo-border-light); }


/* Behavioral */
.personality-section { border-top: 3px solid var(--lywo-primary); }
.beh-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; background: var(--lywo-info-bg); padding: 1rem; border-radius: var(--lywo-radius); margin-bottom: 1rem; }
.link-btn { background: none; border: none; padding: 0; color: var(--lywo-primary); font-weight: 700; font-size: 1rem; border-bottom: 1px dashed currentColor; cursor: pointer; text-align: left;}
.beh-table { width: 100%; border-collapse: collapse; font-size: 0.8rem; border: 1px solid var(--lywo-border-light); margin-top: 0.5rem; }
.beh-table th { text-align: left; padding: 0.4rem; background: #f8fafc; color: #64748b; font-weight: 700; border-bottom: 2px solid #cbd5e1; text-transform: uppercase; font-size: 0.65rem; }
.beh-table th:first-child { width: 15%; }
.beh-table th:nth-child(2) { width: 30%; }
.beh-table th:nth-child(3) { width: 25%; }
.beh-table th:nth-child(4) { width: 30%; }
.beh-table td { padding: 0.4rem; border-bottom: 1px solid var(--lywo-border-light); vertical-align: top; }


/* Highlights & Alerts */
/* UPDATED: Consistent Blue Border */
.card-accent-left { border-left: 4px solid var(--lywo-primary); }
.highlight-item { display: flex; gap: 0.25rem; margin-bottom: 0.25rem; font-size: 0.85rem; }
.card-alert { background-color: var(--lywo-danger-bg); border: 1px solid #f5c6cb; }
.alert-item { background: rgba(255,255,255,0.8); padding: 0.25rem; border-radius: 4px; margin-bottom: 0.25rem; font-size: 0.85rem; color: #842029; border: 1px solid #f5c6cb; }


/* Work History */
.work-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 0.4rem; }
.work-item { background: #fff; border: 1px solid var(--lywo-border-light); padding: 0.5rem; border-radius: 4px; display: flex; flex-direction: column; box-shadow: 0 1px 2px rgba(0,0,0,0.02); }
.work-focus { margin-top: auto; background: #f8f9fa; padding: 0.25rem; border-radius: 4px; border: 1px solid var(--lywo-border-light); font-size: 0.75rem; }


/* Modal & Context Menu */
.context-menu-container { position: relative; display: inline-block; margin-right: 0.4rem; }
.context-menu-btn { background: none; border: none; padding: 3px; border-radius: 4px; cursor: pointer; color: #64748b; transition: background 0.2s; display: flex; align-items: center; }
.context-menu-btn:hover { background-color: #f1f5f9; color: var(--lywo-primary); }


/* Skeletons */
.skeleton { background: #e2e8f0; border-radius: 4px; animation: pulse 1.5s infinite; }
.skeleton-title { height: 18px; width: 60%; margin-bottom: 0.75rem; }
.skeleton-text { height: 12px; width: 100%; margin-bottom: 0.4rem; }
.skeleton-box { height: 80px; width: 100%; }


@keyframes pulse { 0% { opacity: 0.6; } 50% { opacity: 1; } 100% { opacity: 0.6; } }


@media print {
  .btn-print { display: none; }
  .header { position: static; border-bottom: 2px solid #000; }
  .col-left { width: 32%; float: left; padding-right: 15px; }
  .col-right { width: 66%; float: right; }
  .card { break-inside: avoid; border: 1px solid #ccc; box-shadow: none; margin-bottom: 0.75rem; }
  .header-right { text-align: right; }
}
`;


/**
 * =================================================================================
 * COMPONENT DEFINITIONS
 * =================================================================================
 */


// Helper: Get Icon by type
const IconDisplay = ({ type }) => {
  if (!type || typeof type !== 'string') return <LinkIcon size={16} color="#64748b" />;

  switch (type.toLowerCase()) {
    case 'linkedin': return <Linkedin size={16} color="#0077b5" />;
    case 'github': return <Github size={16} color="#333" />;
    case 'facebook': return <Facebook size={16} color="#1877f2" />;
    case 'twitter': return <Twitter size={16} color="#1da1f2" />;
    case 'instagram': return <Instagram size={16} color="#e1306c" />;
    default: return <LinkIcon size={16} color="#64748b" />;
  }
};


const getTagStyle = (tag) => {
  if (!tag || typeof tag !== 'string') return { background: '#f8fafc', color: '#475569', borderColor: '#e2e8f0' };

  const lower = tag.toLowerCase();
  if (['reject', 'not relevant', 'technical gap', 'skill gap'].some(t => lower.includes(t))) {
    return { background: '#fef2f2', color: '#b91c1c', borderColor: '#fecaca' };
  }
  if (['hire', 'select', 'shortlist', 'call to interview', 'interesting', 'culture fit', 'internal transfer'].some(t => lower.includes(t))) {
    return { background: '#f0fdf4', color: '#15803d', borderColor: '#bbf7d0' };
  }
  if (['hold', 'in progress', 'notice period'].some(t => lower.includes(t))) {
    return { background: '#fffbeb', color: '#b45309', borderColor: '#fde68a' };
  }
  return { background: '#f8fafc', color: '#475569', borderColor: '#e2e8f0' };
};


const InfoItem = ({ icon: Icon, color, label, value }) => (
  <div className="profile-row">
    <div className={`icon-box ${color}`}><Icon size={14} /></div>
    <div>
      <p className="profile-label  interRegular">{label}</p>
      <div className=" subHeadingBold interRegular">{value}</div>
    </div>
  </div>
);


const Header = ({ candidate, code, userId, adminData }) => {
  const { handleLogout } = useContext(AppContext);
  const navigate = useNavigate();


  const downloadSummaryReport = () => {
    simpleGetCallWithErrorResponse(ApiConfig.DOWNLOAD_SUMMARY_REPORT + `?code=${code}&userId=${userId}`).then((res) => {
      if (res?.json?.succeded) {
        FileSaver.saveAs(
          `data:application/pdf;base64,${res?.json?.response?.pdfBase64}`,
          candidate?.candidateName + '_Summary_Report.pdf'
        );
      }
    })
  }


  const viewResume = () => {
    if (candidate?.resume) {
      window.open(candidate.resume, '_blank');
    } else {
      toastMsg("info", "Resume document not available");
    }
  }


  const deleteCandidate = () => {
    const url = `${ApiConfig.DELETE_USER_AND_DEP}userid=${userId}`;
    simpleDeleteCall(url, userId).then((res) => {
      if (res?.response?.status) {
        toastMsg("success", "User record deleted successfully.");
        navigate(-1)
      }
    })
  }


  return (
    <header className="app-header">
      <div className="header-main">
        <img src="https://lywo.in/images/logo.svg" alt="LYWO" style={{ height: '30px', maxWidth: '140px' }} />
      </div>


      <div className="d-flex align-items-center gap-2">
        <button
          className="btn btn-outline-primary btn-sm d-flex align-items-center gap-2 text-base"
          onClick={downloadSummaryReport}
          title="Download Summary Report"
          style={{ padding: '0.2rem 0.5rem' }}
        >
          <Download size={14} /> Download PDF
        </button>
      </div>
    </header>
  );
};


// =================================================================================
// REUSABLE COMPONENT: JobProfileCard
// =================================================================================
const JobProfileCard = ({ data }) => {
  if (!data) return null;
  return (
    <div className="card" style={{ borderLeft: '4px solid var(--lywo-primary)', padding: '0.5rem' }}>
      <div className="mb-2">
        <h2
          className="mainHeading interRegular text-dark-navy"
          title={data?.forPosition}
          style={{ margin: '0 0 0.1rem 0' }}
        >
          {data?.forPosition}
        </h2>
        {/* Removed Building2 icon as requested */}
        <div
          className="interRegular headingShortText"
          title={data?.forCompany}
          style={{ display: 'block' }}
        >
          {data?.forCompany}
        </div>
      </div>


      {data?.selectedBehaviourMatch1?.length > 0 && (
        <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '0.5rem' }}>
          <div style={{ textTransform: 'uppercase', marginBottom: '0.3rem', letterSpacing: '0.5px' }}
            className='xlText interRegular subHeadongTextColor'
          >
            Behaviors identified as most relevant for this role
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.5rem' }}>
            {data.selectedBehaviourMatch1.map((b, i) => (
              <div key={i}>
                <div className='subHeadingBold interRegular text-slate-dark'>{b.behaviourName}</div>
                <div style={{ lineHeight: '1.2' }} className='subHeadingNormal interRegular subHeadongTextColor'>{b.description}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};


// =================================================================================
// REUSABLE COMPONENT: PersonalityAnalysisCard
// =================================================================================
const CandidatePersonalityGroupsSection = ({ candidate, handleShowPersonality }) => {
  if (!candidate) return null;


  // Helper to determine badge details
  const getMatchBadge = (status) => {
    if (!status) return null;

    const value = status.toLowerCase();

    const map = {
      excellent: {
        label: "Excellent",
        style: { background: "var(--color-success-bg)", color: "var(--color-success-text)" },
      },
      good: {
        label: "Good",
        style: { background: "#cfe2ff", color: "#084298" }, // blue — no exact token
      },
      normal: {
        label: "Normal",
        style: { background: "var(--color-warning-bg)", color: "var(--color-warning-text)" },
      },
      poor: {
        label: "Poor",
        style: { background: "var(--color-danger-bg)", color: "var(--color-danger-text)" },
      },
    };

    return map[value] || null;
  };



  const renderPersonalityCard = (profile, title, subtitle, matchPercentage, showBadge = false, match) => {
    if (!profile) return null;

    // In production, data is dynamic, so we use the profile object directly.
    const details = {
      summary: profile.shortDescriptions || "Details not available.",
      uniqueness: profile.theirUniqueness || "",
      strengths: profile.strengths || "",
      value: profile.valueToOrganization || "",
      challenges: profile.challenges || "",
      motivations: profile.motivations || ""
    };


    const badgeInfo = (showBadge && match) ? getMatchBadge(match) : null;


    return (
      <div key={title} className="mb-2">
        <div className="d-flex justify-content-between align-items-center mb-1">
          <div className="section-title fw-bold text-navy text-base" style={{ marginBottom: 0 }}>
            {/* Removed User icon as requested */}
            {title}
            <span
              className="fw-bold text-navy text-base"
              style={{ textTransform: 'uppercase', marginLeft: '0.3rem', cursor: 'pointer' }}
              onClick={() => handleShowPersonality && handleShowPersonality(profile.profileName, true)}
            >
              - {profile.profileName}
              {matchPercentage && <span className="text-mid-muted" style={{ marginLeft: '0.3rem' }}>({matchPercentage})</span>}
            </span>
          </div>

          {badgeInfo && (
            <span className="badge text-base" style={{ ...badgeInfo.style }}>
              {badgeInfo.label}
            </span>
          )}
        </div>
        <p style={{ marginTop: 0, marginBottom: '0.3rem', paddingLeft: 0 }} className='subHeadingNormal interRegular subHeadongTextColor'>
          {subtitle}
        </p>

        <div style={{ background: '#fff', padding: '0.5rem', borderRadius: 'var(--lywo-radius)', border: '1px solid var(--lywo-border-light)', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
          <p style={{ marginBottom: '0.5rem', lineHeight: '1.3' }} className='subHeadingNormal interRegular text-slate-dark'>
            {details.summary}
          </p>


          <div className="text-base" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {/* Row 1: Uniqueness */}
            <div>
              <div className="d-flex gap-2 align-items-center mb-0">
                <Sparkles size={14} className="text-warning" />
                <strong className="subHeadingBold interRegular subHeadingColr" style={{ textTransform: 'uppercase' }}>Their Uniqueness</strong>
              </div>
              <div style={{ paddingLeft: '1.4rem', lineHeight: '1.4' }} className='subHeadingNormal interRegular subHeadongTextColor'>{details.uniqueness}</div>
            </div>


            {/* Row 2: Strengths */}
            <div>
              <div className="d-flex gap-2 align-items-center mb-0">
                <Zap size={14} className="text-success" />
                <strong className='subHeadingBold interRegular subHeadingColr' style={{ textTransform: 'uppercase' }}>Strengths</strong>
              </div>
              <div style={{ paddingLeft: '1.4rem', lineHeight: '1.4' }} className='subHeadingNormal interRegular subHeadongTextColor'>{details.strengths}</div>
            </div>


            {/* Row 3: Value */}
            <div>
              <div className="d-flex gap-2 align-items-center mb-0">
                <Gem size={14} className="text-info" />
                <strong className="subHeadingBold interRegular subHeadingColr" style={{ textTransform: 'uppercase' }}>Value to Organization</strong>
              </div>
              <div style={{ paddingLeft: '1.4rem' }} className='subHeadingNormal interRegular subHeadongTextColor'>{details.value}</div>
            </div>


            {/* Row 4: Challenges */}
            <div>
              <div className="d-flex gap-2 align-items-center mb-0">
                <AlertTriangle size={14} className="text-danger" />
                <strong className="subHeadingBold interRegular subHeadingColr" style={{ textTransform: 'uppercase' }}>Their Challenges</strong>
              </div>
              <div style={{ paddingLeft: '1.4rem', lineHeight: '1.4' }} className='subHeadingNormal interRegular subHeadongTextColor'>{details.challenges}</div>
            </div>


            {/* Row 5: Motivations */}
            <div>
              <div className="d-flex gap-2 align-items-center mb-0">
                <Flame size={14} className="text-primary" />
                <strong className="subHeadingBold interRegular subHeadingColr" style={{ textTransform: 'uppercase' }}>What Motivates Them</strong>
              </div>
              <div style={{ paddingLeft: '1.4rem', lineHeight: '1.4' }} className='subHeadingNormal interRegular subHeadongTextColor'>{details.motivations}</div>
            </div>
          </div>
        </div>
      </div>
    );
  };


  return (
    <div className="card card-accent-left">
      <div className="subHeadingBold interRegular text-navy"><User size={14} /> CANDIDATE PERSONALITY GROUPS</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem', marginTop: '0.5rem' }}>
        {renderPersonalityCard(
          candidate?.primaryProfile,
          candidate?.primaryProfile?.profileName == candidate?.secondaryProfile?.profileName ? "Primary and Secondary Personality" : "Primary Personality",
          candidate?.primaryProfile?.profileName == candidate?.secondaryProfile?.profileName ? "A personality that is most observed across situations including stress" : "A personality that is most observed across situations",
          candidate.primaryProfilePercent,
          true,
          candidate?.personalityMatch
        )}

        {candidate?.primaryProfile?.profileName != candidate?.secondaryProfile?.profileName && renderPersonalityCard(
          candidate?.secondaryProfile,
          "Secondary Personality",
          "The alternate personality that is sometimes observed under stress!!",
          candidate.secondaryProfilePercent,
          false
        )}
      </div>
    </div>
  );
};


const ProfileCard = ({ data }) => {
  const viewResume = () => {
    if (data?.resume) {
      window.open(data.resume, '_blank');
    } else {
      if (typeof toastMsg !== 'undefined') toastMsg("info", "Resume document not available");
      else alert("Resume document not available");
    }
  }


  // Extract online presence data safely
  const onlinePresence = data?.resumeMatch?.[0]?.onlinePresence || [];
  const hasOnlinePresence = onlinePresence.length > 0;



  return (
    // Changed styling here: Removed borderTop, added solid header
    <div className="card h-100" style={{ padding: 0, overflow: 'hidden', border: '1px solid #bfdbfe', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>

      {/* Solid Header */}
      <div style={{
        backgroundColor: 'var(--lywo-primary)',
        padding: '0.5rem 0.75rem',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        gap: '0.4rem'
      }}
        className='interRegular xlText'
      >
        <User size={15} className="text-white" /> CANDIDATE PROFILE
      </div>


      <div style={{ padding: '0.75rem' }}>

        <div className="mb-2 pb-2 border-bottom">
          <div className="d-flex justify-content-between align-items-start">
            <div>
              {/* Font size reduced to 1rem to match job position style */}
              <h2 className="fw-bold font-size-h3 text-dark-navy" style={{ margin: '0 0 0.3rem 0' }}>{data?.candidateName}</h2>
              <div className="d-flex flex-column gap-0 text-base text-mid-muted">
                <div className="d-flex align-items-center gap-2 subHeadingNormal interRegular subHeadongTextColor"><Phone size={12} /> {data?.mobile}</div>
                <div className="d-flex align-items-center gap-2 subHeadingNormal interRegular subHeadongTextColor"><Mail size={12} /> {data?.email}</div>
              </div>
            </div>

            {/* View Resume Button moved here */}
            <button
              onClick={viewResume}
              title="View Original Resume"
              style={{
                background: 'white',
                border: '1px solid #e2e8f0',
                borderRadius: '4px',
                height: '26px',
                width: '26px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                color: '#64748b'
              }}
            >
              <FileText size={14} />
            </button>
          </div>
        </div>


        <InfoItem icon={Briefcase} color="blue" label="Total Experience" value={data?.yearsOfExperience} />
        <InfoItem icon={MapPin} color="green" label="Location" value={data?.currentLocation} />
        <InfoItem icon={IndianRupee} color="green" label="Expected Salary" value={data?.expectedSalary} />
        <InfoItem icon={Calendar} color="purple" label="Availability" value={formatToDDMMYYYY(data?.availableBy)} />
        <InfoItem icon={Undo2} color="gray" label="Buy Out" value={data?.buyOutOption ? "Yes" : "No"} />
        <InfoItem icon={HelpCircle} color="purple" label="Assessment" value={data?.technicalScore} />


        {/* Conditionally Render Online Presence */}

        <div className="mt-2 pt-2 border-top">
          <p className="profile-label mb-1">ONLINE PRESENCE</p>
          <div className="d-flex flex-column gap-1">
            {
              hasOnlinePresence ?
                onlinePresence.map((i, idx) => {
                  const link = i?.url?.startsWith("http") ? i.url : `https://${i?.url}`;
                  return (
                    <div key={idx} className="d-flex align-items-center gap-2 text-base">
                      <IconDisplay type={i?.platform} />
                      <a href={link} target="_blank" rel="noopener noreferrer" className="text-decoration-none text-truncate text-primary">
                        {link}
                      </a>
                    </div>
                  );
                }) :
                <div className="text-base text-slate-medium">Not Available</div>
            }
          </div>
        </div>



        <div style={{ marginTop: '0.6rem', paddingTop: '0.6rem', borderTop: '1px solid var(--lywo-border-light)' }}>
          <div className="d-flex gap-2 align-items-start">
            <div className="icon-box gray"><GraduationCap size={14} /></div>
            <div className="w-100">
              <p className="profile-label mb-1">EDUCATION</p>
              <div className="d-flex flex-column">
                {data?.resumeMatch && data?.resumeMatch[0]?.resumeEducationDetails?.map((education, idx) => (
                  <div key={idx} className={idx !== 0 ? "pt-2 border-top border-light mt-1" : "mt-0"}>
                    <div className="d-flex justify-content-between align-items-start mb-0">
                      <div style={{ marginRight: '0.5rem', overflow: 'hidden' }}>
                        <div style={{ lineHeight: '1.2', wordBreak: 'break-word' }}
                          className='subHeadingBold interRegular'
                        >
                          {education?.educationType}{education?.qualification && (
                            <>
                              <br />
                              ({education.qualification})
                            </>
                          )}
                        </div>
                        <div style={{ wordBreak: 'break-word', marginTop: '1px' }} className='subHeadingNormal interRegular subHeadongTextColor'>
                          {education?.institution}
                        </div>
                      </div>
                      <div className="text-end flex-shrink-0 text-base text-slate-medium">
                        <div style={{ whiteSpace: 'nowrap' }}>{education?.completionYear}</div>
                        {education?.percentageCGPA !== 'N/A' && (
                          <div className="fw-semibold text-dark" style={{ marginTop: '1px' }}>
                            {education?.percentageCGPA}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


const QuestionnaireCard = ({ data }) => (
  <div className="card" style={{ borderLeft: '4px solid var(--lywo-primary)' }}>
    <div className="section-title"><CheckSquare size={14} /> CUSTOM QUESTIONS</div>
    {data?.customQuestions?.map((item, i) => (
      <div key={i} className="list-item">
        <span style={{ maxWidth: '85%', }} className='subHeadingNormal interRegular subHeadongTextColor'>{item?.questionText}</span>
        {/* Fix: logic adjusted to find answer in current item object using matching index convention or fallback */}
        <span className={`badge ${data[`ans${i + 1}`] === 'Yes' ? 'good' : 'bad'}`}> {data[`ans${i + 1}`] || 'N/A'}</span>
      </div>
    ))}
  </div>
);


const NotesSection = ({ data }) => {
  // Check if adminNotes array exists and is not empty
  if (!data?.adminNotes || data.adminNotes.length === 0) {
    return (
      <div className="card" style={{ borderLeft: '4px solid var(--lywo-primary)' }}>
        <div className="section-title"><MessageSquare size={14} /> COLLABORATORS NOTES</div>
        <div className="text-base text-slate-medium" style={{ padding: '0.2rem' }}>Not Available</div>
      </div>
    );
  }

  return (
    <div className="card" style={{ borderLeft: '4px solid var(--lywo-primary)' }}>
      <div className="section-title"><MessageSquare size={14} /> COLLABORATORS NOTES</div>
      {data.adminNotes.map((note, i) => (
        <div key={i} className="note-card">
          <div className="note-header">
            <strong className='subHeadingBold interRegular subHeadingColr'>{note?.email}</strong>
            <span className="text-base text-slate-medium" style={{ fontFamily: 'monospace' }}> {formatDate(note?.createdAt)}</span>
          </div>
          <p className='subHeadingNormal interRegular subHeadongTextColor text-base' style={{ margin: 0 }}>{note?.notes}</p>
        </div>
      ))}
    </div>
  );
};


const HighlightsSection = ({ data }) => (
  <div className="card highlight-card card-accent-left">
    <div className="section-title mb-2">
      <Award size={14} className='font-size-h4 interRegular' /> RESUME HIGHLIGHTS
    </div>

    <div className="text-base" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
      {data?.resumeMatch && data?.resumeMatch[0]?.matchDetails?.map((pt, i) => (

        <div>
          <div className="d-flex gap-2 align-items-center mb-1">
            <Star size={14} className="text-warning" />
            <strong style={{ textTransform: 'uppercase' }} className='subHeadingBold interRegular subHeadingColr'>{pt?.title}</strong>
          </div>
          <div style={{ paddingLeft: '1.4rem' }} className='subHeadingNormal interRegular subHeadongTextColor'>{pt?.description}</div>
        </div>

        // <div key={i} className="highlight-item">
        //   <Star size={14} color="#f97316" style={{ marginTop: 2, flexShrink: 0 }} />
        //   <div><strong style={{ color: '#475569', fontSize: 'var(--font-size-base)', textTransform: 'uppercase' }}>{pt?.title}:</strong> <span style={{ color: '#1e293b', paddingLeft: '1.4rem' }}>{pt?.description}</span></div>
        // </div> *

      ))}
    </div>
  </div>
);


const WorkHistorySection = ({ data }) => (
  <div className="card">
    <div className="section-title"><Briefcase size={14} /> WORK HISTORY</div>
    <div className="d-flex flex-column gap-2">
      {data?.resumeMatch && data?.resumeMatch[0]?.workHistoryDetails?.map((job, i) => {
        // Internship Logic
        const isIntern = job?.position?.toLowerCase().includes('intern');
        const label = isIntern ? 'INTERN' : 'FOCUS';

        return (
          <div key={i} className="work-item" style={{
            background: '#fff',
            border: '1px solid #e2e8f0',
            borderLeft: '3px solid #cbd5e1',
            padding: '0.5rem',
            borderRadius: '4px',
            boxShadow: '0 1px 2px rgba(0,0,0,0.02)'
          }}>
            {/* Row 1: Position (Standalone) */}
            <div
              className="subHeadingBold interRegular subHeadingColr"
              title={job?.position}
              style={{ marginBottom: '0.1rem' }}
            >
              {job?.position}
            </div>


            {/* Row 2: Company */}
            <div className="d-flex justify-content-between align-items-center mb-1">
              <div
                className="text-truncate subHeadingBold interRegular subHeadongTextColor text-base text-slate-medium"
                title={job?.company}
                style={{ marginBottom: '0.3rem' }}
              >
                {job?.company?.length > 40 ? job?.company?.slice(0, 40) : job?.company}
              </div>
              <div className="text-base text-mid-muted" style={{
                whiteSpace: 'nowrap',
                fontFamily: 'monospace',
                background: '#f1f5f9',
                padding: '1px 5px',
                borderRadius: '3px',
                border: '1px solid #e2e8f0',
                flexShrink: 0,
                marginTop: '-7px'
              }}>
                {job?.duration
                  ? job.duration
                    .replace(/to/i, "-")
                    .replace(/present/i, "Now")
                  : ""}
              </div>
            </div>

            {/* Row 3: Label + Timeline (Same Row) */}
            {/* <div className="d-flex justify-content-between align-items-center mb-1" style={{ borderTop: '1px dashed #e2e8f0', paddingTop: '0.3rem' }}>
              <span style={{ fontWeight: '700', color: '#94a3b8', fontSize: '0.65rem', textTransform: 'uppercase' }}>
                {label}
              </span> 
            <div style={{
              whiteSpace: 'nowrap',
              fontSize: '0.65rem',
              fontFamily: 'monospace',
              background: '#f1f5f9',
              padding: '1px 5px',
              borderRadius: '3px',
              color: '#475569',
              border: '1px solid #e2e8f0',
              flexShrink: 0
            }}>
              {job?.duration ? job.duration.replace("to", "-") : ""}
            </div>
          </div> * /}


            {/* Row 4: Content (Full Width) */ }
            <div style={{ lineHeight: '1.4' }} className='subHeadingNormal interRegular subHeadongTextColor'>
              {job?.focus}
            </div>
          </div>
        );
      })}
    </div>
  </div >
);


const CandidateDashboard = () => {
  const [modalTitle, setModalTitle] = useState(null);
  const { code, userId } = useParams();
  const { adminData } = useContext(AppContext);
  const [personalityDetails, setPersonalityDetails] = useState({ isOpen: false, per: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [candidateData, setCandidateData] = useState({});


  useEffect(() => {



    getSummary();
  }, []);


  const handlePersonality = useCallback((per, isOpen) => {
    setPersonalityDetails({ isOpen: isOpen, per: per });
  }, []);


  const getSummary = () => {
    setIsLoading(true);
    simpleGetCallWithErrorResponse(ApiConfig.GET_SUMMARY_REPORT + `UserId=${userId}&Code=${code}&Admin=${adminData?.email}`).then((res) => {
      if (res?.json?.succeded) {
        setCandidateData(res?.json?.response);
        if (!res?.json?.response?.resumeMatch) {
          toastMsg("info", "Resume Match data not found for this candidate.");
        }

        document.title = res?.json?.response?.candidateName + " - Candidate Summary";

      }
      setIsLoading(false);
    });
  };


  const ProfileSkeleton = () => (
    <div className="card">
      <div className="skeleton skeleton-title" />
      {[1, 2, 3, 4, 5].map(i => (<div key={i} className="skeleton skeleton-text" />))}
      <div className="skeleton skeleton-box mt-3" />
    </div>
  );


  const MainContentSkeleton = () => (
    <div className="d-flex flex-column gap-1">
      <div className="card"><div className="skeleton skeleton-title" style={{ width: '40%' }} /></div>
      <div className="card"><div className="skeleton skeleton-box" style={{ height: '150px' }} /></div>
      <div className="card"><div className="skeleton skeleton-box" style={{ height: '300px' }} /></div>
    </div>
  );


  return (
    <>
      <style>{`@import url('https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css'); ${CSS_STYLES}`}</style>


      <div className="mainWrap">
        <Header candidate={candidateData} code={code} userId={userId} adminData={adminData} />


        <div className="container mt-2">
          <div className="row g-1">
            {/* Left Sidebar */}
            <div className="col-lg-4">
              <div className="d-flex flex-column gap-1">
                {isLoading ? <ProfileSkeleton /> : <ProfileCard data={candidateData} />}
                {/* WorkHistorySection moved here as requested in previous turns */}
                {isLoading ? <ProfileSkeleton /> : <WorkHistorySection data={candidateData} />}
              </div>
            </div>


            {/* Main Content Area */}
            <div className="col-lg-8">
              {isLoading ? (
                <MainContentSkeleton />
              ) : (
                <div className="d-flex flex-column gap-1">

                  {/* REUSABLE COMPONENT: JobProfileCard */}
                  <JobProfileCard
                    data={candidateData}
                  />


                  {/* REUSABLE COMPONENT: PersonalityAnalysisCard */}
                  <CandidatePersonalityGroupsSection
                    candidate={candidateData}
                    handleShowPersonality={handlePersonality}
                  />

                  {/* Notes Section moved here (Full Width) */}
                  <div className="row g-1">
                    <div className="col-12">
                      <NotesSection data={candidateData} />
                    </div>
                  </div>


                  {/* Custom Questions (QuestionnaireCard) */}
                  <QuestionnaireCard data={candidateData} />
                  <HighlightsSection data={candidateData} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* NOTE FOR PRODUCTION:
        If you have imported PersonalityDetails from '../component/personalityDeatils' (sic),
        you can use that component directly here.
        Below is the inline version used for the preview environment.
      */}
      <PersonalityDetails
        isOpen={personalityDetails?.isOpen}
        per={personalityDetails?.per}
        handleShowPersonality={handlePersonality}
      />

    </>
  );
};

export default CandidateDashboard;
/* * =================================================================================
 * SECTION 3: PREVIEW WRAPPER (DELETE THIS ENTIRE SECTION WHEN INTEGRATING)
 * =================================================================================
 */


